module.exports = __webpack_public_path__ + "static/media/shop03.9a5c2a35.png";